"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedTypeError = void 0;
const custom_error_1 = require("./custom-error");
class UnsupportedTypeError extends custom_error_1.CustomError {
    constructor(scanType) {
        super('Provided scan type is not supported', custom_error_1.ERROR_CODES.UnsupportedTypeError);
        this.scanType = scanType;
    }
}
exports.UnsupportedTypeError = UnsupportedTypeError;
//# sourceMappingURL=unsupported-type-error.js.map